import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ICourseForUser } from '../CoursesSlice';
import { ISectionForUser } from '.';

export type TCancelCourseZoomSectionAsUser = {
  _id: string;
  reason: string;
};

export type TRescheduleCourseZoomSectionAsUser = {
  sectionId: string;
  reason: string;
  start: string;
  end: string;
  duration: number;
  title: string;
  isReschduleFreeSlot?: boolean;
};

const apiDataProvider = new APIDataProvider();

export const getUserCourseSectionsByCourseId = createAsyncThunk(
  '/courses/id/sections',
  async (id: string) => {
    const path = `${ApiPaths.courses}/${id}?subSections=1`;
    const response = await apiDataProvider.get<TApiResponse<ICourseForUser>>(
      path
    );

    return response.data;
  }
);

export const cancelCoursZoomeSectionAsUser = createAsyncThunk(
  '/sections/cancelOneZoom',
  async (data: TCancelCourseZoomSectionAsUser) => {
    const path = `${ApiPaths.zoomMeetings}/cancel/${data._id}`;
    const response = await apiDataProvider.put<TApiResponse<ISectionForUser>>(
      path,
      data
    );

    return response.data;
  }
);

export const rescheduleCoursZoomeSectionAsUser = createAsyncThunk(
  '/sections/rescheduleOneZoom',
  async (data: TRescheduleCourseZoomSectionAsUser) => {
    const path = `${ApiPaths.zoomMeetings}/reschedule/${data.sectionId}`;
    const response = await apiDataProvider.put<TApiResponse<ISectionForUser>>(
      path,
      data
    );

    return response.data;
  }
);

export const getSectionByIdAsUser = createAsyncThunk(
  '/sections/getOne',
  async (data: { id: string }) => {
    const path = `${ApiPaths.sections}/${data.id}`;
    const response = await apiDataProvider.get<TApiResponse<ISectionForUser>>(
      path
    );

    return response.data;
  }
);
